import { render, staticRenderFns } from "./PelleUpgrade.vue?vue&type=template&id=5c6ad248&scoped=true&"
import script from "./PelleUpgrade.vue?vue&type=script&lang=js&"
export * from "./PelleUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./PelleUpgrade.vue?vue&type=style&index=0&id=5c6ad248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6ad248",
  null
  
)

export default component.exports